import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

let accessToken = localStorage.getItem("tr_token") || null;
let accountId = localStorage.getItem("tr_account") || null;

export const setViewAs = (id) => {
  if (id) localStorage.setItem("tr_view_as", id);
  else localStorage.removeItem("tr_view_as");
};
export const getViewAs = () => localStorage.getItem("tr_view_as");

export const setToken = (t) => {
  accessToken = t;
  if (t) localStorage.setItem("tr_token", t);
  else localStorage.removeItem("tr_token");
};

export const setActiveAccount = (id) => {
  accountId = id;
  if (id) localStorage.setItem("tr_account", id);
  else localStorage.removeItem("tr_account");
};

export const getActiveAccount = () => accountId;

api.interceptors.request.use((config) => {
  if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
  if (accountId) config.headers["X-Account-Id"] = accountId;
  const district = localStorage.getItem("tr_district");
  if (district) config.headers["X-District-Id"] = district;
  const viewAs = localStorage.getItem("tr_view_as");
  if (viewAs) config.headers["X-View-As"] = viewAs;
  return config;
});

// When a mutation is attempted during a read-only View-As preview the server returns 403 with this
// marker — surface a clear, friendly toast instead of a generic error.
api.interceptors.response.use((r) => r, (err) => {
  if (err?.response?.status === 403 && err?.response?.data?.view_as_readonly) {
    toast.error("Read-only preview — exit View As to make changes.");
  }
  return Promise.reject(err);
});

export function apiError(err, fallback = "Something went wrong. Please try again.") {
  const d = err?.response?.data?.detail ?? err?.response?.data;
  if (d == null) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (typeof e === "string" ? e : e?.msg || JSON.stringify(e))).join(" ");
  if (typeof d === "object") {
    if (typeof d.message === "string") return d.message;
    if (typeof d.error === "string") return d.error;
    if (typeof d.msg === "string") return d.msg;
    if (d.field_errors && typeof d.field_errors === "object") return Object.values(d.field_errors).join(" ");
    return err?.message || fallback;
  }
  return String(d);
}

export default api;
